<template>
  <Collapse accordion class="collapse-slider mt-15">
    <CollapseItem :title="complaintTitle" :name="complaintTitle">
      <div >
        <div style="height: 35vh;">
          <div class="text-right">
            <Button class="el-button el-button--secondary"
              :style="disableComplaintSaveAction ? 'cursor: not-allowed; opacity: 0.6;' : ''"
              @click="save">{{ $t('SAVE') }}</Button>
          </div>
          <div class="my-15 table-with-add" style="width: 92%;">
            <div class="add-block" @click="addNewComplaint" style="">
                {{ $t('ADD_COMPLAINT') }}
            </div>
          <div style="max-height: 300px; overflow-y: auto;">
            <Table class="table-striped bordered" :data="mergedComplaints" highlight-current-row
                    :row-key="row => row.id ? `id-${row.id}` : `sno-${row.sno}`" lazy
                    aria-describedby="complaintDetailsTableData" :max-height="260"
                    style="height: auto; display: flex; flex-direction: column; flex: 1; gap: 1rem;">
              <TableColumn v-for="(item, index) in getComplaintHeaders" :key="index" :label="item.title"
                  :width="item.width">
                  <template slot-scope="scope" style="margin-bottom: 4rem;">
                      <span class="d-block" :class="{ 'read-only-complaint': isComplaintReadOnly(scope.row) }">
                          <Select
                              v-if="item.paramKey === 'complaint_type' && complaintReasons && complaintReasons.length"
                              :placeholder="getInputPlaceholder(item, scope.row)" size="mini"
                              :required="item.required" :value="getInputModel(item, scope.row)"
                              :disabled="item.disabled || isComplaintReadOnly(scope.row)"
                              @input="val => setInputModel(item, scope.row, val)" popper-class="text-right"
                              class="select-default" style="background: transparent;">
                              <Option v-for="reason in complaintReasons" :key="reason" :value="reason"
                                  :label="reason">
                                  {{ reason }}
                              </Option>
                          </Select>
                          <Select
                              v-else-if="item.paramKey === 'material_code' && availableMaterials && availableMaterials.length"
                              :placeholder="getInputPlaceholder(item, scope.row)" popper-class="text-right"
                              class="select-default" size="mini" :required="item.required"
                              :value="getInputModel(item, scope.row)"
                              :disabled="item.disabled || isComplaintReadOnly(scope.row)"
                              @input="val => setInputModel(item, scope.row, val)" filterable allow-create
                              default-first-option>
                              <Option v-for="material in availableMaterials" :key="material.value"
                                  :value="material.value" :label="material.label">
                                  {{ material.label }}
                              </Option>
                          </Select>
                          <Select
                              v-else-if="item.paramKey === 'quantity_uom' && quantityUOM && quantityUOM.length"
                              :placeholder="getInputPlaceholder(item, scope.row)" popper-class="text-right"
                              class="select-default" size="mini" :required="item.required"
                              :value="getInputModel(item, scope.row)"
                              :disabled="item.disabled || isComplaintReadOnly(scope.row)"
                              @input="val => setInputModel(item, scope.row, val)" filterable allow-create
                              default-first-option>
                              <Option v-for="quantity in quantityUOM" :key="quantity.value"
                                  :value="quantity.value" :label="quantity.label">
                                  {{ quantity.label }}
                              </Option>
                          </Select>
                          <Tooltip v-else-if="item.type === 'input' && item.paramKey === 'complaint_description'"
                              :content="getInputModel(item, scope.row) || 'No description available'"
                              :disabled="!getInputModel(item, scope.row)" placement="top" effect="dark">
                              <Input :placeholder="getInputPlaceholder(item, scope.row)"
                                  class="input-blank p-0 bold" size="mini" :required="item.required" type="text"
                                  :value="getInputModel(item, scope.row)"
                                  :readonly="isComplaintReadOnly(scope.row)" :disabled="item.disabled"
                                  @input="val => setInputModel(item, scope.row, val)" />
                          </Tooltip>
                          <Input v-else-if="item.type === 'input'"
                              :placeholder="getInputPlaceholder(item, scope.row)" class="input-blank p-0 bold"
                              size="mini" :required="item.required" type="text"
                              :value="getInputModel(item, scope.row)" :readonly="isComplaintReadOnly(scope.row)"
                              :disabled="item.disabled" @input="val => setInputModel(item, scope.row, val)" />
                          <Attachments v-if="item.type === 'attachment'"
                              :attachments="getFilteredAttachments(scope.row)" :multiple="true" :maxAllowed="attachmentsLimit"
                              @addAttachments="(file) => addAttachments(file, scope.row, scope.$index)"
                              @removeAttachments="(file) => removeAttachments(file, scope.row, scope.$index)"
                              :readOnly="isComplaintReadOnly(scope.row)" :smallIcons="true" :showPreview="true">
                          </Attachments>

                      </span>
                  </template>
              </TableColumn>
              <TableColumn label=" " width="10">
                <template slot-scope="scope" v-if="!scope.row.savedToDb">
                  <div class="custom-popover" v-if="showDeleteSlot === scope.$index">
                    {{  $t('DELETE_COMPLAINT_CNFRM') }}
                    <span class="text-bold ml-5">
                      <span class="d-inline pointer" @click="deleteComplaint(scope.row, scope.$index)">{{ $t('INDENT_YES')}}</span>
                      /
                      <span class="d-inline pointer" @click="showDeleteSlot= null">{{  $t('INDENT_PROMPT_NO') }}</span>
                    </span>
                  </div>
                  <Tooltip :open-delay="100" effect="dark" placement="bottom">
                    <div slot="content">{{ $t('INDENT_DELETE') }}</div>
                    <i class="action-row" @click="showDeletePop(scope.$index)">
                      <svgicon name="icon-delete-md" width="14" height="14" />
                    </i>
                  </Tooltip>
                </template>
            </TableColumn>
            </Table>
          </div>
          </div>
        </div>
      </div>
    </CollapseItem>
  </Collapse>
</template>

<script>
import { complaintColumns } from '@/constants/complaints';
import { mapGetters } from 'vuex';
import Attachments from '@common/components/Attachments';
import CustomerComplaints from '@common/components/customer-complaints';
import { cloneDeep } from 'lodash';
import { complaintReasons } from 'pando-constants';


export default {
  components: {
    Attachments,
    CustomerComplaints,
  },
  props: ['selectedConsignee', 'orderDetails', 'complaintsForCurrentDrop', 'materialsList'],
  beforeDestroy() {
    this.$store.commit('order/UNSAVED_COMPLAINTS_WARNED_ONCE', false);
    this.$store.commit('order/UPDATE_UNSAVED_COMPLAINTS_FLAG', false);
  },
  computed: {
    ...mapGetters({
      isComplaintsLoading: 'order/isComplaintsLoading',
      currentClient: 'app/currentClient',
      configurations: 'app/configurations',
      hasUnsavedComplaints: 'order/hasUnsavedComplaints',
    }),
    attachmentsLimit() {
      return (this.configurations.attachmentsLimit && this.configurations.attachmentsLimit.customer_complaints) || 5;
    },
    quantityUOM() {
      return (this.configurations.complaints_quantity_uom || ['IT', 'CS']).map(item => ({
        value: item,
        label: item,
      }),
      );
    },
    availableMaterials() {
      const uniqMap = {};
      return Object.values(this.materialsList).flat().reduce((acc, item) => {
        if (!uniqMap[item.material.code]) {
          acc.push({
            value: item.material.code,
            label: item.material.code,
            delivery_number: item.material_ref_id,
            invoice_number: item.invoice.number,
          });
        }
        return acc;
      }, []);
    },
    hasEmptyFields() {
      return this.hasInvalidRows();
    },
    getComplaintHeaders() {
      const allHeaders = this.complaintColumns.map((col) => {
        const modification = { isCustom: false };
        if (col.paramKey === 'amount') {
          const currency = this.currentClient.currency
            ? this.$getCurrencySymbol(this.currentClient.currency)
            : this.$getCurrencySymbol('INR');
          modification.title = `Amount (${currency})`;
        }
        return Object.assign({}, col, modification);
      });

      const nonAttachments = allHeaders.filter(h => h.type !== 'attachment');
      const attachments = allHeaders.filter(h => h.type === 'attachment');

      return [...nonAttachments, ...attachments];
    },
    disableComplaintSaveAction() {
      const hasPermission = this.$hasPermission('raise_complaints');
      const shouldDisable = !hasPermission;
      return shouldDisable;
    },
    mergedComplaints() {
      const localComplaints = this.localComplaints.map(complaint => Object.assign({}, complaint, {
        savedToDb: false,
        isReadOnly: false,
      }));
      return localComplaints.concat(this.modifiedComplaints);
    },
    complaintTitle() {
      const complaintNo = this.complaintsForCurrentDrop.length
        ? this.complaintsForCurrentDrop[0].complaint_no : null;
      return complaintNo
        ? `Complaints - ${complaintNo}`
        : 'Complaints';
    },
    modifiedComplaints() {
      const initializedComplaints = cloneDeep(this.complaintsForCurrentDrop).map(item => Object.assign({}, item, {
        custom_fields: item.custom_fields || {},
        isUpdated: false,
        savedToDb: true,
      }));
      return initializedComplaints;
    },
    getComplaintDetailHeaders() {
      const dbHeaders = [];
      const customHeaders = dbHeaders.map(item => ({
        title: item.label || item.title,
        paramKey: item.name,
        type: item.type === 'textbox' ? 'input' : item.type || 'input',
        required: item.required || false,
        width: item.width || '150px',
        disabled: item.disabled || false,
        isCustom: true,
      }));

      // Add isCustom to parent headers
      const parentHeaders = this.complaintColumns.map(col =>
        Object.assign({}, col, { isCustom: false }),
      );

      // Merge all headers first
      const allHeaders = [...parentHeaders, ...customHeaders];

      // Sort: non-attachments first, then attachments
      const nonAttachments = allHeaders.filter(h => h.type !== 'attachment');
      const attachments = allHeaders.filter(h => h.type === 'attachment');

      return [...nonAttachments, ...attachments];
    },
  },
  data() {
    return {
      complaintColumns,
      localComplaints: [],
      attachments: {},
      selectedRows: [],
      showDeleteSlot: null,
      complaintReasons,
    };
  },
  methods: {
    deleteComplaint(complaint, index) {
      this.localComplaints.splice(index, 1);
      this.showDeleteSlot = null;
    },
    showDeletePop(index) {
      this.showDeleteSlot = index;
    },
    isComplaintReadOnly(row) {
      if (row.sno && !row.id) {
        return this.disableComplaintSaveAction;
      }

      const result = row.isReadOnly || row.savedToDb || this.disableComplaintSaveAction;
      return result;
    },
    hasInvalidRows() {
      return this.mergedComplaints.some(row => !row.material_code || !row.complaint_type || !row.quantity);
    },
    markRowUpdated(row) {
      if (!row) {
        console.warn('No row provided to mark as updated');
        return;
      }
      this.$set(row, 'isUpdated', true);
    },
    addNewComplaint() {
      if (this.disableComplaintSaveAction) {
        return;
      }
      const newRow = {
        material_code: '',
        batch_id: '',
        complaint_type: '',
        quantity: '',
        quantity_uom: '',
        complaint_description: '',
        attachment_ids: [],
        custom_fields: {},
        sno: Date.now(),
        isUpdated: true,
        savedToDb: false,
        isReadOnly: false,
        destination_location_id: this.selectedConsignee.location_id,
        destination_gate_id: this.selectedConsignee.gate_id,
        delivery_number: '',
        invoice_number: '',
        cctv_link: '',
      };

      const columns = this.getComplaintHeaders || [];
      columns.forEach((column) => {
        if (column.type === 'input' && column.paramKey) {
          if (column.isCustom) {
            newRow.custom_fields = newRow.custom_fields || {};
            newRow.custom_fields[column.paramKey] = '';
          }
        }
        if (column.type === 'dropdown' && column.paramKey) {
          if (column.isCustom) {
            newRow.custom_fields = newRow.custom_fields || {};
            newRow.custom_fields[column.paramKey] = [];
          }
        }
      });

      this.localComplaints.push(newRow);
      if (!this.hasUnsavedComplaints) {
        this.$store.commit('order/UPDATE_UNSAVED_COMPLAINTS_FLAG', true);
      }
    },
    isSameItem(a, b) {
      return (a.id && b.id && a.id === b.id) ||
                (a.sno && b.sno && a.sno === b.sno);
    },
    async save() {
      try {
        const modifiedExistingRows = Array.isArray(this.modifiedComplaints)
          ? this.modifiedComplaints.filter(row => row.isUpdated && !this.isComplaintReadOnly(row))
          : [];
        const filteredLocalComplaints = this.localComplaints.filter(row => !this.isComplaintReadOnly(row));
        const allChangedRows = modifiedExistingRows.concat(filteredLocalComplaints);

        if (allChangedRows.length === 0) {
          this.$errorMessage({ message: 'No changes to save' });
          return;
        }

        const formattedComplaints = allChangedRows.map((data) => {
          const destination_location_id = data.destination_location_id !== undefined && data.destination_location_id !== null
            ? data.destination_location_id
            : (this.selectedConsignee && this.selectedConsignee.location_id) || null;

          const destination_gate_id = data.destination_gate_id !== undefined && data.destination_gate_id !== null
            ? data.destination_gate_id
            : (this.selectedConsignee && this.selectedConsignee.gate_id) || null;

          // Ensure attachment_ids are properly formatted
          let attachmentIds = [];
          if (data.attachment_ids && Array.isArray(data.attachment_ids)) {
            attachmentIds = data.attachment_ids.map((att) => {
              if (typeof att === 'object' && att.id) {
                return att.id;
              }
              return att;
            }).filter(id => id); // Remove null/undefined values
          }

          const complaint = {
            destination_location_id,
            destination_gate_id,
            material_code: data.material_code || '',
            batch_id: data.batch_id || data.branch_id || '', // Handle both field names
            quantity: data.quantity ? Number(data.quantity) : 0,
            quantity_uom: data.quantity_uom || data.uom || '',
            complaint_type: data.complaint_type || '',
            complaint_description: data.complaint_description || data.remarks || '',
            attachment_ids: attachmentIds,
            amount: data.amount,
            delivery_number: data.delivery_number,
            invoice_number: data.invoice_number,
            cctv_link: data.cctv_link,
          };

          if (data.id) {
            complaint.id = data.id;
          }

          return complaint;
        }).filter((complaint) => {
          const isValid = complaint.destination_location_id;
          return isValid;
        });

        if (formattedComplaints.length === 0) {
          this.$message.warning('No valid complaints to save. Please check required fields.');
          return;
        }

        const payload = {
          data: formattedComplaints,
          order_no: this.orderDetails.order_number,
        };


        const result = await this.$store.dispatch('order/addCustomerComplaints', payload);
        if (result === 'Created') {
          this.$successMessage({
            message: 'Complaints saved successfully',
          });

          this.localComplaints = [];

          this.modifiedComplaints.forEach((complaint) => {
            this.$set(complaint, 'isUpdated', false);
          });
          await this.fetchComplaints();
        } else if (result.data && result.data.errors) {
          this.$errorMessage({ message: result.data.errors[0].message });
        } else {
          const errorMessage = 'Failed to save complaints';
          this.$errorMessage({ message: errorMessage });
        }
        this.$store.commit('order/UPDATE_UNSAVED_COMPLAINTS_FLAG', false);
      } catch (error) {
        this.$errorMessage({
          message: `Failed to save complaints: ${error.message}`,
        });
        this.$nextTick(() => this.$forceUpdate());
      }
    },
    getInputPlaceholder(item, row) {
      if (item.isCustom) {
        return row.custom_fields[item.paramKey] || `Enter ${item.title}`;
      }
      return row[item.paramKey] || `Enter ${item.title}`;
    },
    getInputModel(item, row) {
      return item.isCustom ? row.custom_fields[item.paramKey] : row[item.paramKey];
    },
    setInputModel(item, row, value) {
      if (this.isComplaintReadOnly(row)) {
        return;
      }
      let sourceRow = row;
      if (row.sno && !row.id) {
        const localIndex = this.localComplaints.findIndex(local => local.sno === row.sno);
        if (localIndex >= 0) {
          sourceRow = this.localComplaints[localIndex];
        }
      } else if (row.id) {
        const modifiedIndex = this.modifiedComplaints.findIndex(modified => modified.id === row.id);
        if (modifiedIndex >= 0) {
          sourceRow = this.modifiedComplaints[modifiedIndex];
        }
      }

      if (item.isCustom) {
        this.$set(sourceRow.custom_fields, item.paramKey, value);
      } else {
        this.$set(sourceRow, item.paramKey, value);
      }
      if (item.id === 'material_code') {
        const matchedMaterial = this.availableMaterials.find(material => material.value === value);
        if (matchedMaterial) {
          this.$set(sourceRow, 'delivery_number', matchedMaterial.delivery_number);
          this.$set(sourceRow, 'invoice_number', matchedMaterial.invoice_number);
        }
      }
      this.$set(sourceRow, 'isUpdated', true);
    },
    getFilteredAttachments(row) {
      // Handle different attachment structures
      let attachments = [];

      if (row.attachment_ids && Array.isArray(row.attachment_ids)) {
        attachments = row.attachment_ids;
      } else if (row.attachments && Array.isArray(row.attachments)) {
        attachments = row.attachments;
      }

      if (!attachments.length) {
        return [];
      }

      return attachments.map(att =>
      // Handle different attachment object structures
        ({
          uid: att.id || att.uid,
          id: att.id || att.uid,
          name: att.name || att.filename || 'Attachment',
          url: att.attachment_url || att.url || att.file_url,
        }),
      ).filter(att => att.id); // Filter out invalid attachments
    },
    async addAttachments(file, row) {
      try {
        this.markRowUpdated(row);
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const result = await this.$store.dispatch('order/addAttachment', formData);

        if (result.error) {
          this.$error({ message: result.error || this.$getErr('UPLOAD_FAILS') });
          return;
        }

        if (!result.id || !result.attachment_url) {
          throw new Error('Invalid response format - missing required fields');
        }

        const attachmentData = {
          id: result.id,
          name: file.name,
          attachment_url: result.attachment_url,
        };

        let sourceRow = row;
        if (row.sno && !row.id) {
          const localIndex = this.localComplaints.findIndex(local => local.sno === row.sno);
          if (localIndex >= 0) {
            sourceRow = this.localComplaints[localIndex];
          }
        } else if (row.id) {
          const modifiedIndex = this.modifiedComplaints.findIndex(modified => modified.id === row.id);
          if (modifiedIndex >= 0) {
            sourceRow = this.modifiedComplaints[modifiedIndex];
          }
        }

        if (!sourceRow.attachment_ids) {
          this.$set(sourceRow, 'attachment_ids', [attachmentData]);
        } else {
          const newAttachmentIds = sourceRow.attachment_ids.concat([attachmentData]);
          this.$set(sourceRow, 'attachment_ids', newAttachmentIds);
        }

        this.$set(sourceRow, 'isUpdated', true);
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$error({ message: apiError || this.$getErr('UPLOAD_FAILS'), description: apiError });
      }
    },

    async removeAttachments(file, row) {
      try {
        const payload = {
          attachment_id: file.id,
        };

        const result = await this.$store.dispatch('order/removeAttachments', payload);
        this.markRowUpdated(row);
        if (result === 'OK') {
          // Find and update the source row
          let sourceRow = row;
          if (row.sno && !row.id) {
            const localIndex = this.localComplaints.findIndex(local => local.sno === row.sno);
            if (localIndex >= 0) {
              sourceRow = this.localComplaints[localIndex];
            }
          } else if (row.id) {
            const modifiedIndex = this.modifiedComplaints.findIndex(modified => modified.id === row.id);
            if (modifiedIndex >= 0) {
              sourceRow = this.modifiedComplaints[modifiedIndex];
            }
          }

          // Update source row attachments
          if (sourceRow && Array.isArray(sourceRow.attachment_ids)) {
            this.$set(sourceRow, 'attachment_ids',
              sourceRow.attachment_ids.filter(att => att.id !== file.id),
            );
          }
          this.$set(sourceRow, 'isUpdated', true);
        }
      } catch (error) {
        this.$error({ message: 'Failed to remove attachment' });
      }
    },
    async fetchComplaints() {
      const orderId = this.$route.params.orderId || this.$route.params.orderNo;
      if (orderId) {
        await this.$store.dispatch('order/complaints', orderId);
      }
    },
  },

};
</script>
<style lang="scss" scoped>
.tab-content {
    overflow-y: auto;
    height: 81vh;
    position: fixed;
    width: 50%;
}

.complaint-card {
    background: white;
    border-radius: 2px;
    border: 1px solid #e5e5e5;
    padding: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.icon-list {
    display: flex;
    align-items: center;
    width: 4rem;
    align-items: center;
    justify-content: center;
    color: white;
    height: 4rem;
    // padding: 0.1rem;
    border-radius: 50%;
    border: 0.5px solid #E9F1F5;
    background: #F8F8F8;
}

.attachment {
    display: flex;
    padding: 4px 8px;
    align-items: center;
    gap: 5px;
    border-radius: 12px;
    border: 0.5px solid #E9F1F5;
    background: #F8F8F8;
}

.card-body {
    flex-direction: column;
    align-items: start;
}

.detail-label {
    color: #333333;
    white-space: nowrap;
}

.status-badge {
    background-color: #DCFCE7;
    color: #166534;
    padding: 4px 12px;
    border-radius: 5px;
    font-size: 10px;
    border: 1px solid #BBF7D0;
    display: flex;
    padding: 0.5px 2px;
    align-items: center;
    gap: 10px;
}

.description {
    color: #4a4a4a;
    line-height: 1.0;
    background: #F9FAFA;
}

.des {
    margin-left: 5px;
    margin: 0.5em 1em;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    background: #F9FAFA;
    border-radius: 3px;
}

.complaint-card:hover {
    background: #EEF2F4;
    border-radius: 2px;
    border: 1px solid #E2EAEC;
    padding: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.complaint-content {
    width: 60%;
    height: 32vh;
    overflow: auto;
}
.table-striped.bordered.mt-10 {
    margin-bottom: 2rem;
}

.read-only-complaint {
    opacity: 0.8;
    background-color: #f8f9fa;
    border-radius: 4px;
    padding: 2px;
}

.read-only-complaint input,
.read-only-complaint .el-input__inner,
.read-only-complaint .el-select .el-input__inner {
    background-color: #f8f9fa !important;
    color: #6c757d !important;
    cursor: default !important;
    border-color: #e9ecef !important;
}

.read-only-complaint .el-select {
    pointer-events: none;
}

.read-only-checkbox {
    opacity: 0.5;
    pointer-events: none;
}

.read-only-complaint .el-input.is-disabled .el-input__inner {
    background-color: #f8f9fa !important;
    border-color: #e9ecef !important;
    color: #6c757d !important;
}

/* Readonly input styling - different from disabled */
.el-input[readonly] .el-input__inner,
.el-input__inner[readonly] {
    background-color: #f8f9fa !important;
    color: #495057 !important;
    cursor: text !important;
    border-color: #ced4da !important;
}

/* Ensure readonly inputs are still selectable for copying */
.el-input[readonly] .el-input__inner:focus,
.el-input__inner[readonly]:focus {
    border-color: #80bdff !important;
    outline: 0 !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

</style>
